export const TRADING_POSITIONS_SORT_STORAGE_KEY =
  "orderly_trading_positions_sort";
export const LIQ_DISTANCE_THRESHOLD = 10;
